module.exports = __webpack_public_path__ + "img/jb_t-7275_94_a_c.prt.7a0b7e24.jpg";